module.exports = __webpack_public_path__ + "static/media/03.1805c465.jpg";